export class AddRemoveCustomer {
	// TODO
}